import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n\ttext-transform: uppercase;\n"]);

  _templateObject7 = function () {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n\tmark {\n\t\tbackground: ", ";\n\t\tborder-radius: 2px;\n\t\tbox-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05) inset,\n\t\t\t0 -1px 0 rgba(0, 0, 0, 0.1) inset;\n\t}\n"]);

  _templateObject6 = function () {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n\tcolor: ", ";\n"]);

  _templateObject5 = function () {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\tcolor: ", ";\n"]);

  _templateObject4 = function () {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\tcolor: ", ";\n"]);

  _templateObject3 = function () {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: block;\n"]);

  _templateObject2 = function () {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tcolor: ", ";\n\tline-height: ", ";\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import { css, ui } from '@wp-g2/styles';
export var Text = css(_templateObject(), ui.color.text, ui.get('fontLineHeightBase'));
export var block = css(_templateObject2());
export var positive = css(_templateObject3(), ui.color.positive);
export var destructive = css(_templateObject4(), ui.color.destructive);
export var muted = css(_templateObject5(), ui.get('colorTextMuted'));
export var highlighterText = css(_templateObject6(), ui.get('yellowRgba70'));
export var upperCase = css(_templateObject7());